import React from 'react';
import typography from '../../utils/typography';
import { SerializedStyles, css } from '@emotion/core';
import { useTheme } from '@veneer/theme';

const useStyles = (): Record<'root', SerializedStyles> => {
  const theme = useTheme();
  return React.useMemo(
    () => ({
      root: css({
        boxSizing: 'border-box',
        color: theme.color.foreground.light,
        display: 'block',
        ...typography(theme).captionSmall,
        margin: `0 -${theme.layout.size2}`,
        padding: `0 ${theme.layout.size3} ${theme.layout.size2}`,
        position: 'relative',
        userSelect: 'none',

        '&:nth-last-of-type(1)': {
          borderTop: `1px solid ${theme.color.stroke.default}`,
          paddingTop: theme.layout.size3,
        },
      }),
    }),
    [theme]
  );
};

export default useStyles;
